import { render, staticRenderFns } from "./Step1Identify.vue?vue&type=template&id=0dbe828b&scoped=true&"
import script from "./Step1Identify.vue?vue&type=script&lang=js&"
export * from "./Step1Identify.vue?vue&type=script&lang=js&"
import style0 from "./Step1Identify.vue?vue&type=style&index=0&id=0dbe828b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbe828b",
  null
  
)

export default component.exports